
export const syScrollToEnd = (ref:any) => {
    
    return  ref.current.scrollIntoView({ behavior: 'smooth' });;
  }